import {
  UPLTWrapper,
  UPLTWrapperProps,
} from "@faire/retailer-visitor-shared/components/UPLT/UPLTWrapper";
import * as React from "react";

export const MaybeUPLTWrapper = (
  props: UPLTWrapperProps & {
    shouldTrackUPLT: boolean;
  }
) => {
  if (props.shouldTrackUPLT) {
    return <UPLTWrapper {...props} />;
  }

  return <>{props.children}</>;
};
